import React from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import "../ROIC/ROIC.css";

const data = [
  { name: "Year 1", ROIC: 25, WACC: -5, Difference: 20 },
  { name: "Year 2", ROIC: 27, WACC: -7, Difference: 20 },
  { name: "Year 3", ROIC: 30, WACC: -5, Difference: 30 },
  { name: "Year 4", ROIC: 32, WACC: -5, Difference: 25 },
  { name: "Year 5", ROIC: 28, WACC: -6, Difference: 10 },
  { name: "Year 6", ROIC: 33, WACC: -8, Difference: 25 },
  { name: "Year 7", ROIC: 35, WACC: -7, Difference: 28 },
  { name: "Year 8", ROIC: 30, WACC: -10, Difference: 20 },
];

const ROIC = () => {
  return (
    <div className="roic-container">
      <h2>ROIC vs WACC: Yearly Trends and Value Creation</h2>
      <ResponsiveContainer width="100%" height={450}>
        <ComposedChart
          height={400}
          data={data}
          margin={{ top: 20, right: 10, left: 10, bottom: 20 }}
        >
          <CartesianGrid stroke="#e8e8e8" strokeDasharray="dashLength spaceLength" vertical={false} />
          <XAxis dataKey="name" />
          <YAxis yAxisId="right" orientation="right" />
          <Tooltip />
          <Legend layout="horizontal" verticalAlign="bottom" align="center" />
          
          {/* Bars and line will use the right Y-axis */}
          <Bar
            yAxisId="right"
            dataKey="ROIC"
            fill="#58a65c"
            barSize={15}
          />
          <Bar
            yAxisId="right"
            dataKey="WACC"
            fill="#d85140"
            barSize={15}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="Difference"
            stroke="black"
            strokeWidth={3}
            dot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ROIC;
